import { AdminSourceResponse, IdProvider } from "@authory-packages/core";

export const getHashAnchor = (source: AdminSourceResponse) =>
  `#${
    source.rootId
      ? IdProvider.toRootId(source.rootId)
      : IdProvider.toWebsiteId(source.id)
  }`;

export const goToAnchor = (source: AdminSourceResponse) => {
  const hashAnchor = getHashAnchor(source);
  const anchor = document
    .querySelector(`a[href='${hashAnchor}']`)
    ?.closest(".MuiPaper-root");

  if (anchor) {
    const y = anchor.getBoundingClientRect().top;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    window.scrollTo({ top: y + scrollTop - 55, behavior: "smooth" });
  }
};
